
import CabifyBanner from '../cabifyClone/CabifyBanner'
import GroceryLogos from './GroceryLogos';
import { lazy, Suspense } from 'react';

const ShuttleAppreciation = lazy(() => import('../../shuttle_software/ShuttleAppreciation'));
const TaxiFaq = lazy(() => import('../../taxiDispatchSoftware/TaxiFaq'));
const GroceryAccelerate = lazy(() => import('./GroceryAccelerate'));
const GroceryAppPrefered = lazy(() => import('./GroceryAppPrefered'));
const GroceryAppWork = lazy(() => import('./GroceryAppWork'));
const GroceryChoose = lazy(() => import('./GroceryChoose'));
const GroceryDeliveryApp = lazy(() => import('./GroceryDeliveryApp'));
const GroceryFeatures = lazy(() => import('./GroceryFeatures'));
const GroceryMarket = lazy(() => import('./GroceryMarket'));
const GroceryModel = lazy(() => import('./GroceryModel'));
const GroceryPlatform = lazy(() => import('./GroceryPlatform'));
const GrocerySuccess = lazy(() => import('./GrocerySuccess'));
const GroceryTech = lazy(() => import('./GroceryTech'));

export default function GroceryApp() {



  const bannerData = {
    title: "Launch Your Grocery App Like Instacart or Shipt",
    description: "Take your grocery business online with a powerful, ready-to-launch solution.Whether you're a local grocer or a regional supermarket chain, our white-label grocery app gives you everything you need to compete with the big names—Instacart, Shipt, FreshDirect, and more.",
    image: "/assets/home/grocery-banner.webp",
    btn: "get free demo",
    breadcrumbData: {
      newClass: "white-breadcrumb",
      list: [
        {
          page: "Home",
          slug: "/"
        },
        {
          page: "Grocery Clone App",
          slug: ""
        },
      ]
    }
  };


  const forYouData = {
    newClass: "bolt-for-you",
    text1: "$50 Billion+ Market",
    text2: "Opportunity in Grocery",
    des: "The U.S. grocery delivery industry is booming. Be part of this explosive growth by launching your own branded app with Mobility Infotech.",
    btn: "Build Your App",
  }






  const faqData = [
    {
      id: "0",
      question: "01. What is a Grocery Clone App?",
      answer: " A grocery clone app is a ready-made software solution modeled after top platforms like Instacart and Shipt. It lets you launch your own branded grocery delivery business quickly, with features like order tracking, secure payments, and real-time delivery.",
    },
    {
      id: "1",
      question: "02. Can I customize the app to match my store’s branding? ",
      answer: "Yes, 100%. Our white-label solution allows you to customize the app’s logo, color scheme, features, user interface, and even the domain to reflect your unique brand identity.",
    },
    {
      id: "2",
      question: "03. How long does it take to launch the grocery app? ",
      answer: " With our ready-to-use clone script, you can launch your fully branded grocery delivery app in as little as 7 to 21 days, depending on the level of customization you need.",
    },
    {
      id: "3",
      question: "04. Do you support multiple store locations or vendors?",
      answer: " Absolutely. Our platform supports all business models—single store, grocery marketplace, and multi-store chains—with centralized control for inventory, pricing, and deliveries.",
    },
    {
      id: "4",
      question: "05.  What kind of support do you offer post-launch? ",
      answer: "We provide 12 months of free technical support, including bug fixes, updates, and maintenance to ensure your app runs smoothly post-deployment.",
    },
    {
      id: "5",
      question: "06. Is the app compatible with both iOS and Android? ",
      answer: " Yes! We deliver pre-built apps for both iOS and Android, plus a Progressive Web App (PWA) for web access—ensuring your customers can shop from any device.",
    },

    {
      id: "6",
      question: "07. Are there any recurring charges or hidden fees? ",
      answer: " No. Our grocery clone app comes with one-time pricing, complete source code ownership, and no monthly charges. You fully own your platform.",
    },
  ];

  return (
    <>
      <CabifyBanner data={bannerData} NewClass='grocery-banner' />
      <GroceryLogos />

      <Suspense fallback={null}>
        <GroceryAccelerate />
        <GroceryTech />
        <GroceryChoose />
        <GroceryPlatform />
        <GrocerySuccess />
        <GroceryMarket data={forYouData} />
        <GroceryModel />
        <GroceryFeatures />
        <GroceryAppWork />
        <GroceryAppPrefered />
        <ShuttleAppreciation />
        <div className="zip-faq-fixer">
          <TaxiFaq faqData={faqData} />
        </div>
        <GroceryDeliveryApp />
      </Suspense>
    </>
  )
}
